/**
 * add safe area inset bottom to value
 */
export default function withSafeAreaInsetBottom(value?: string) {
  if(!value) {
    return 'env(safe-area-inset-bottom)';
  }

  return `calc(env(safe-area-inset-bottom) + ${value})`
}
